<app-modal>
  <div header>
    <span>{{ title }}</span>
  </div>

  <div body>
    <div class="w-full flex flex-row justify-center">
      <form [formGroup]="patientConsultationForm" (ngSubmit)="saveConsultationNotes()" class="w-full">
          <textarea formControlName="notes" id="" cols="30" rows="10"
                    class="text-area-default w-full"
                    placeholder="{{ 'EnterNotesHere' | localizeText : 'Enter Notes Here' }}"></textarea>
      </form>
    </div>
  </div>

  <div footer>
    <div class="w-full flex flex-row space-x-1 justify-end">
      <app-button btnTxt="{{ 'Cancel' | localizeText : 'Cancel' }}" buttonType="warning" class="modal-close"></app-button>

      <app-button
        (click)="saveConsultationNotes()"
        [loading$]="loading$"
        type="button"
        btnTxt="{{ 'Save' | localizeText : 'Save' }}"
      ></app-button>
    </div>
  </div>
</app-modal>
